import { addMonths, endOfDay, isAfter, addYears } from "date-fns";
export class ConsentExpirationService {
    constructor(stateLawsService) {
        this.stateLawsService = stateLawsService;
    }
    getConsentExpiration(studyCompletionDate, patientState) {
        if (!studyCompletionDate || !patientState) {
            const now = new Date();
            return addYears(now, 1);
        }
        const maxConsentExpiryMonths = this.stateLawsService.getMaxConsentExpiryMonths(patientState);
        if (maxConsentExpiryMonths === null) {
            return endOfDay(new Date(studyCompletionDate));
        }
        const maximumAllowedByLaw = addMonths(new Date(), maxConsentExpiryMonths);
        if (isAfter(studyCompletionDate, maximumAllowedByLaw)) {
            return endOfDay(maximumAllowedByLaw);
        }
        else {
            return endOfDay(studyCompletionDate);
        }
    }
}
